// Dev Environment

// export const API_PROJECT_BASE_URL = 'http://13.233.225.198:8082';

// export const API_TASK_BASE_URL = 'http://13.233.225.198:8083';

// export const API_USER_BASE_URL = 'http://13.233.225.198:8080';

// export const API_STOMP_BASE_URL = 'http://13.233.225.198:8081';

// export const API_S3_BASE_URL = 'http://13.233.225.198:8088';

// export const API_INVENTORY_URL = 'http://13.233.225.198:9001';

//Old Prod Environment
// export const API_PROJECT_BASE_URL = 'http://3.109.134.153:8082';

// export const API_TASK_BASE_URL = 'http://3.109.134.153:8083';

// export const API_USER_BASE_URL = 'http://3.109.134.153:8080';

// export const API_STOMP_BASE_URL = 'http://3.109.134.153:8081';

// export const API_S3_BASE_URL = 'http://3.109.134.153:8088';

//New Prod Environment - Merger

//testing

// export const API_PROJECT_BASE_URL = 'https://terraform-backend-4.vintech.co.in/projects';

// export const API_TASK_BASE_URL = 'https://terraform-backend-4.vintech.co.in/task';

// export const API_USER_BASE_URL = 'https://terraform-backend-4.vintech.co.in/user';

// export const API_STOMP_BASE_URL = 'https://terraform-backend-4.vintech.co.in/chat';

// export const API_S3_BASE_URL = 'https://terraform-backend-4.vintech.co.in/s3';

// export const API_INVENTORY_BASE_URL = 'https://terraform-backend-4.vintech.co.in/inventory';

// export const API_HRMS_BASE_URL = 'https://terraform-backend-4.vintech.co.in/hrms';

// export const API_CRM_BASE_URL = 'https://terraform-backend-4.vintech.co.in/crm';

//production

export const API_PROJECT_BASE_URL = 'https://backend.dhariyamarine.app/projects';

export const API_TASK_BASE_URL = 'https://backend.dhariyamarine.app/task';
export const API_USER_BASE_URL = 'https://backend.dhariyamarine.app/user';

export const API_STOMP_BASE_URL = 'https://backend.dhariyamarine.app/chat';

export const API_S3_BASE_URL = 'https://backend.dhariyamarine.app/s3';


export const API_INVENTORY_BASE_URL =
  'https://backend.dhariyamarine.app/inventory';

export const API_HRMS_BASE_URL = 'https://backend.dhariyamarine.app/hrms';
export const API_CRM_BASE_URL = 'https://backend.dhariyamarine.app/crm';
export const API_NOTIFICATION_BASE_URL = 'https://backend.dhariyamarine.app/notification';
export const API_ASSET_BASE_URL = 'https://backend.dhariyamarine.app/asset';

// export const API_HRMS_BASE_URL = 'https://backend.technobuild.in/hrms';
// export const API_CRM_BASE_URL = 'https://backend.technobuild.in/crm';

//terraform


// export const API_PROJECT_BASE_URL =
//   'https://terraform-backend.vintech.co.in/projects';

// export const API_TASK_BASE_URL = 'https://terraform-backend.vintech.co.in/task';

// export const API_USER_BASE_URL = 'https://terraform-backend.vintech.co.in/user';

// export const API_STOMP_BASE_URL =
//   'https://terraform-backend.vintech.co.in/chat';

// export const API_S3_BASE_URL = 'https://terraform-backend.vintech.co.in/s3';

// export const API_INVENTORY_BASE_URL =
//   'https://terraform-backend.vintech.co.in/inventory';

// export const API_CRM_BASE_URL = 'https://terraform-backend.vintech.co.in/crm';

//scari

// export const API_PROJECT_BASE_URL =
//   'https://backend-scarisbricks.vintech.co.in/projects';

// export const API_TASK_BASE_URL =
//   'https://backend-scarisbricks.vintech.co.in/task';

// export const API_USER_BASE_URL =
//   'https://backend-scarisbricks.vintech.co.in/user';

// export const API_STOMP_BASE_URL =
//   'https://backend-scarisbricks.vintech.co.in/chat';

// export const API_S3_BASE_URL = 'https://backend-scarisbricks.vintech.co.in/s3';

// export const API_INVENTORY_BASE_URL =
//   'https://backend-scarisbricks.vintech.co.in/inventory';

//Local

// export const API_PROJECT_BASE_URL = 'http://localhost:8761/projects';

// export const API_TASK_BASE_URL = 'http://localhost:8761/task';

// export const API_USER_BASE_URL = 'http://localhost:8761/user';

// export const API_STOMP_BASE_URL = 'http://localhost:8761/chat';

// export const API_S3_BASE_URL = 'http://localhost:8761/s3';

// export const API_INVENTORY_BASE_URL = 'http://localhost:8761/inventory';

// export const API_HRMS_BASE_URL = 'http://localhost:8761/hrms';

// export const API_CRM_BASE_URL = 'http://localhost:8761/crm';

// export const API_PROJECT_BASE_URL = '/api/p';

// export const API_TASK_BASE_URL = '/api/t';

// export const API_USER_BASE_URL = '/api/u';

// export const API_STOMP_BASE_URL = '/api/m';
